import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TextSubHeading, TextCallout2, Link, Button } from 'blocket-ui'

const Wrapper = styled.div`
  padding 16px;
  background-color: #fff;
`

const SectionWrapper = styled.div`
  margin: 8px 0;
`

const StyledImg = styled.img`
  max-width: 100%;
  display: block;
  margin: 0 auto;
`

const StyledTextCallout2 = styled(TextCallout2)`
  padding-bottom: 5px;
`

export default function Teaser({ ctaText, ctaUrl, header, body, img }) {
  return (
    <Wrapper>
      <SectionWrapper>
        <Link to={ctaUrl}>
          <StyledImg src={img.src} alt={img.alt} />
        </Link>
      </SectionWrapper>
      <SectionWrapper>
        <TextSubHeading tagName="h2">{header}</TextSubHeading>
      </SectionWrapper>
      <SectionWrapper>
        <StyledTextCallout2 tagName="p">{body}</StyledTextCallout2>
      </SectionWrapper>
      <SectionWrapper>
        <Button type="secondary" size="small" href={ctaUrl}>
          {ctaText}
        </Button>
      </SectionWrapper>
    </Wrapper>
  )
}

Teaser.propTypes = {
  ctaText: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
}
